import { css } from '@emotion/react';
import t from 'react-translate';
import { Recruitment } from 'redux/schemas/models/mentoring-program-recruitments';
import { notHandheld } from 'styles/global_defaults/media-queries';
import { standardSpacing } from 'styles/global_defaults/scaffolding';
import { ReactComponent as WhoThisIsForIcon } from 'styles/icons/customer-success.svg';
import { ReactComponent as WhyJoinIcon } from 'styles/icons/training-providers.svg';
import { ReactComponent as WhatToExpectIcon } from 'styles/icons/employee-onboarding.svg';
import { iconLargeSize } from 'styles/global_defaults/icons';


const styles = css`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${standardSpacing}px;

  ${notHandheld(css`
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    grid-template-columns: unset;
  `)}

  .info-section {
    max-width: 400px;
  }
`;

type FlyerInfoProps = {
  recruitment?: Recruitment;
};

const FlyerInfo = ({ recruitment }: FlyerInfoProps) => {
  const {
    requirements,
    includeRequirements,
    benefits,
    includeBenefits,
    expectations,
    includeExpectations,
  } = recruitment ?? {};

  if (
    (!includeRequirements || !requirements)
    && (!includeBenefits || !benefits)
    && (!includeExpectations || !expectations)
  ) {
    return null;
  }

  return (
    <div className='py-5 border-top border-gray-6' css={styles}>
      {includeRequirements && requirements && (
        <div className='info-section mx-auto p-3 d-flex flex-column align-items-center'>
          <WhoThisIsForIcon width={iconLargeSize} height={iconLargeSize} />
          <div className='semi-bold color-gray-1 p-3'>
            {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.WHO_THIS_IS_FOR()}
          </div>
          <div
            className='d-flex flex-column align-items-center'
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: requirements }}
          />
        </div>
      )}
      {includeExpectations && expectations && (
        <div className='info-section mx-auto p-3 d-flex flex-column align-items-center'>
          <WhatToExpectIcon width={iconLargeSize} height={iconLargeSize} />
          <div className='semi-bold color-gray-1 p-3'>
            {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.WHAT_TO_EXPECT()}
          </div>
          <div
            className='d-flex flex-column align-items-center'
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: expectations }}
          />
        </div>
      )}
      {includeBenefits && benefits && (
        <div className='info-section mx-auto p-3 d-flex flex-column align-items-center'>
          <WhyJoinIcon width={iconLargeSize} height={iconLargeSize} />
          <div className='semi-bold color-gray-1 p-3'>
            {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.WHY_JOIN()}
          </div>
          <div
            className='d-flex flex-column align-items-center'
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: benefits }}
          />
        </div>
      )}
    </div>
  );
};

export default FlyerInfo;
